export enum E_Network {
  SEPOLIA = 'sepolia',
  BASE = 'base',
  BASE_SEPOLIA = 'base-sepolia'
}
